import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { ProductComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';

export class ProductComponentExtend {
  public static Init(dto: ProductComponent) {
    dto.componentType = EnumComponentType.Product;
  }
}
